import { get } from "lodash";
import { RunnerBI } from "../../hooks/useGetRunnerFromBI";
import { BestPerformanceStats } from "./types";

export const getTopRunnersWithComments = (runners: RunnerBI[]) =>
  runners.filter((runner) => {
    const timeform = get(runner, "timeform.freePick.number", 4);
    const timeformHasComments = !!get(runner, "timeform.freePick.info");

    const handicapping = get(runner, "handicapping.freePick.number", 4);
    const handicappingHasComments = !!get(runner, "handicapping.freePick.info");

    return (
      (timeform <= 3 && timeformHasComments) ||
      (handicapping <= 3 && handicappingHasComments)
    );
  });

const getBestValue = (
  runner: RunnerBI,
  acc: Record<string, number>,
  key: string
) => {
  const runnerValue: number = get(runner, key, 0);
  const bestValue: number = get(acc, key, 0);

  return runnerValue > bestValue ? runnerValue : bestValue;
};

export const getBestRunnersStats = (runners: RunnerBI[]) =>
  runners.reduce(
    (acc: BestPerformanceStats, runner: RunnerBI): BestPerformanceStats => {
      Object.keys(acc).forEach((key) => {
        acc[key as keyof BestPerformanceStats] = getBestValue(runner, acc, key);
      });

      return acc;
    },
    {
      jockeyTrainerStarts: 0,
      jockeyTrainerWinPercentage: 0,
      jockeyTrainerTop3Percentage: 0,
      avgSpeed: 0,
      avgClass: 0,
      highSpeed: 0,
      numberOfStarts: 0,
      powerRating: 0,
      top3Percentage: 0,
      winPercentage: 0,
      daysOff: 0
    }
  );
